<template>
<div class="container">
<b-row v-if="!isLoading">
<h3>
	<label for="desde">Desde</label> &nbsp;
	<input type="date" name="" id="desde" v-model="desde" @click="desde='';hasta='';pais='';paises=false;fgl_mensaje=false;">&nbsp; 
	<label for="hasta">Hasta</label> &nbsp;
	<input type="date" name="" id="hasta" v-model="hasta" @click="hasta='';pais='';paises=false" @input="f_seleccione_pais()">&nbsp; 
	<label >País</label>
	<select v-model="pais" @click="f_traiga_informacion()">
		<option
			v-for="(item, idx) in listPaises"
			:key="idx"
			:value="item.pais">
			{{item.pais}}
		</option>
	</select>
</h3>
<b-container >
	<md-table v-if="listCruce.length>0">
		<h1 class="md-title"><b><i>{{f_titulo()}}</i></b></h1>&nbsp;&nbsp;
		<h3 class="md-title"><b><i>{{listCruce.length}}&nbsp;Documentos</i></b></h3>
	</md-table>
	<md-table v-model="listCruce" md-card md-fixed-header>
	<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
		<md-table-cell :md-label="labels.identificacion" class="text-left border">{{item.identificacion}}</md-table-cell>
		<md-table-cell :md-label="labels.nombre" class="text-left border">{{item.razon_social}}</md-table-cell>
		<md-table-cell :md-label="labels.factura" class="text-left border">{{item.factura}}</md-table-cell>
		<md-table-cell :md-label="labels.fecha_factura" class="text-left border">{{item.fecha}}</md-table-cell>
		<md-table-cell :md-label="labels.llave" class="text-left border">{{item.car_sunat}}</md-table-cell>
	</md-table-row>
	</md-table>
</b-container>
</b-row>
</div>
</template>
<script>
import Seguimiento from "@/services/Seguimiento"
import User from "@/services/User"
import Estado from "@/services/Estados"

export default {
name:'Cargados',
data: () => ({
	isLoading: false,
	Fecha : false,
	Lider : false,
	Usuario : false,
	opcion: 0,
	operacion: '',
	factura: '',
	pais: '',
	paises: false,
	titulo_factura: "",
	titulo_estado: "",
	users : [],
	listEstados : [],
	listPaises : [],
	listCruce : [],
	desde: '',
	hasta: '',
	recarga: '',
}),
computed:{
labels(){
	if (this.$store.state._language == "es-ES") {
		return {
			title : "FACTURAS",
			factura : "Factura",
			fecha_factura : "Fecha",
			identificacion : "Identificación",
			nombre : "Nombre del Proveedor",
			llave : "CAR SUNAT",
		}
	}else{
		return {
			title : "INVOICES",
			factura : "Invoice",
			fecha : "Date",
			identificacion : "Identification",
			proveedor : "Name",
			cantidad : "Invoices",
			pedido : "Order",
			valor : "Amount",
			impuesto0 : "Tax0",
			categoria0 : "Category0",
			impuesto1 : "Tax1",
			categoria1 : "Category1",
			impuesto2 : "Tax2",
			categoria2 : "Category2",
			impuesto : "Taxes",
			valor_total : "Total Amount",
			items : "Items",
			estado: "Condition",
			lider: "Leader",
			lider_nombre: "Leader Name",
			usuario: "User",
			usuario_nombre: "User Name",
		}
	}
}
},
mounted(){
	User.getAllUsers(this.$store.state.userName)
	.then((result) => {
		this.users = result.data.users;
	})
	.catch((err) => {
		console.log(err)
	})
	Seguimiento.leaTodosPaises()
	.then((res) => {
		this.listPaises = res.data.listPaises
		this.pais=''
		if	(this.listPaises.lenght>0) {
			this.paises=true
		}
	})
	.catch((err) => {
		console.log(err)
	})
	Estado.leaEstados(false)
	.then((result) => {
		this.listEstados = result.data.listEstados;
	})
	.catch((err) => {
		console.log(err)
	})
},
methods:{
	f_titulo() {
		if      (this.$route.name == "Sreptodos") {
			return "DOCUMENTOS REPORTADOS DESDE "+
				this.desde+" HASTA "+this.hasta
		} else {
			return "DOCUMENTOS REPORTADOS NO CARGADOS DESDE "+
				this.desde+" HASTA "+this.hasta
		}
	},
	f_muestra_detalle(r_factura) {
		this.factura=r_factura
	},
	f_usuario_nombre(p_id) {
		if	(p_id === null) {
			return ""
		}
		const v_usuario=this.users.find((r_usuario) => r_usuario.id==p_id
						)
		return v_usuario.name
	},
	f_traiga_informacion() {
		
		if      (this.$route.name == "Sreptodos") {
			Seguimiento.informacionReportados(this.pais,this.desde,this.hasta)
			.then((res) => {
				this.listCruce = res.data.listCruce
				if	(this.listCruce.length==0) {
					this.$toast.error("No existen registros para la consulta")		
				}
			})
			.catch((err) => {
				console.log(err)
			})
		} else {
			Seguimiento.informacionCruceReportados(this.pais,this.desde,this.hasta,this.$store.state.userId)
			.then((res) => {
				this.listCruce = res.data.listCruce
				if	(this.listCruce.length==0) {
					this.$toast.error("No existen registros para la consulta")		
				}
			})
			.catch((err) => {
				console.log(err)
			})
		}
	},
	f_seleccione_pais() {
		this.paises = true
	},
}

}
</script>

<style>

</style>
